import PocRouteAnalysisHeaderComponent from './poc_route_analysis_header.componenet';
import { Box } from '@mui/material';
import RouteAnalysisForm from './poc_route_analysis_form.component';
import React, { useState, useEffect } from 'react';
import { getRoutesForPoc } from '../functions/get_routes_for_poc.function';
import { useSetAtom } from 'jotai';
import { allDeploymentRoutes } from '../../../common/atom/atoms';

export default function RouteAnalysis() {
  const [routes, setRoutes] = useState([]);
  const setAllDeploymentRoutes = useSetAtom(allDeploymentRoutes);

  useEffect(() => {
    const fetchRoutes = async () => {
      try {
        const routesData = await getRoutesForPoc();
        setRoutes(routesData); // Save the fetched routes
        setAllDeploymentRoutes(routesData);
      } catch (error) {
        console.error('Error fetching routes:', error);
      }
    };

    fetchRoutes();
  }, []);
  return (
    <>
      <PocRouteAnalysisHeaderComponent routes={routes} />
      {/* <Box
        sx={{
            display: 'flex',
            justifyContent: 'center',  // Center horizontally
            alignItems: 'center',      // Center vertically
            height: 'calc(100vh - 50px)', // Adjust based on the header height
            backgroundColor: '#f4f4f4', // Optional background color
            padding: 2
        }}
            > */}
      <RouteAnalysisForm routes={routes} />
      {/* </Box> */}
    </>
  );
}
